module.exports = __webpack_public_path__ + "components/discount-pages/db-journey/static/surf-icon-190abf2cd8a25c10471a5eafbed714a4.svg";